import { c as _c } from "react/compiler-runtime";
import { SVGProps } from "react";
export const FlightLuggage = properties => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fillRule="evenodd" d="M9.509 4.973 10 7.11c-1.159.155-1.774.705-1.8 2.491L7.07 7.426l-2.983 2.996.246 1.715c.02.123-.02.24-.11.324l-.317.323a.386.386 0 0 1-.609-.084L2.19 10.694.196 9.581a.386.386 0 0 1-.084-.608l.317-.324a.38.38 0 0 1 .324-.11l1.708.246 2.984-2.996L.708 3.304a.81.81 0 0 1 .556-1.508l6.62 1.534L10.861.34a1.14 1.14 0 0 1 1.625 0 1.15 1.15 0 0 1 0 1.63L9.502 4.968zm4.083 2.796a.253.253 0 0 1-.252-.252V5.892c0-.142.116-.252.252-.252h1.01c.142 0 .252.116.252.252v1.625a.253.253 0 0 1-.252.252zm-2.271 5.747h8.076v-4.22c0-.42-.149-.783-.446-1.08a1.46 1.46 0 0 0-1.075-.447h-1.734V5.472a.7.7 0 0 0-.213-.531c-.15-.149-.246-.233-.46-.233h-2.77c-.213 0-.317.084-.46.233a.73.73 0 0 0-.213.53V7.77h-1.734c-.414 0-.777.149-1.074.447-.298.297-.447.66-.447 1.08v4.22h2.55m-1.023 6.232c0 .142.117.252.253.252h1.01a.253.253 0 0 0 .252-.252v-.512h4.55v.512c0 .142.116.252.252.252h1.009a.253.253 0 0 0 .252-.252v-.512q.63 0 1.075-.446.446-.448.446-1.08v-3.735h-4.55v.414a.253.253 0 0 1-.252.253h-1.01a.253.253 0 0 1-.252-.253v-.414H8.784v3.734c0 .42.149.783.447 1.08q.444.447 1.074.447v.512z" clipRule="evenodd" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== properties) {
    t1 = <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" {...properties}>{t0}</svg>;
    $[1] = properties;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};